import React, { useRef, useEffect, useState } from "react";
import { ChevronLeftOutlined, ChevronRightOutlined } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

import Record from "./Record.react";
import { firestore } from "firebase";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "80%",
    maxWidth: "800px",
    margin: "auto",
    marginTop: 20,

    [theme.breakpoints.up("md")]: {
      marginTop: 80,
    },
  },
  questions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  prompt: {
    padding: "0px 12px",
    textAlign: "center",
  },
  intro: {
    maxWidth: "600px",
    margin: "auto",
    marginBottom: 20,
    textAlign: "left",

    [theme.breakpoints.up("md")]: {
      textAlign: "center",
    },
  },
  disabled: {
    opacity: "0.2",
    cursor: "not-allowed",
  },
  enabled: {
    cursor: "pointer",
  },
}));

export default function Signup() {
  const styles = useStyles();
  const [questions, setQuestions] = useState(null);
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);
  const [recordingState, setRecordingState] = useState("ready");

  useEffect(() => {
    firestore()
      .collection("questions")
      .get()
      .then((snap) => {
        const docs = snap.docs;
        setQuestions(
          shuffleArray(docs.map((doc) => ({ id: doc.id, ...doc.data() })))
        );
      });
  }, []);

  // start recording
  const startCallback = () => {
    setRecordingState("started");
  };

  // end recording
  const endCallback = () => {
    setRecordingState("finished");
  };

  // uploading
  const uploadingCallback = () => {
    setRecordingState("uploading");
  };

  // saved
  const savedCallback = () => {
    setRecordingState("saved");
  };

  console.log(questions);

  const activeQuestion =
    questions != null ? questions[activeQuestionIndex] : null;
  return questions != null && activeQuestion != null ? (
    <div className={styles.container}>
      <div className={styles.intro}>
        <h1>AloneTogether</h1>
        <p>
          In the midst of the pandemic and all of the crazy, tragic, silly and
          unexpected situations that have come along with it, sometimes it is
          necessary to take a step back and reflect on all that has happened. We
          have created a space where you can talk out your frenzy of thoughts.
          <br />
          <br />
          Take this as an opportunity to vent, tell a funny story, spill your
          deepest darkest secrets, or just share what's on your mind! Shout into
          the abyss and see where your voice takes you. Pick a question, record
          and submit and send your voice out into the world.
        </p>
      </div>
      <div className={styles.questions}>
        <ChevronLeftOutlined
          className={
            recordingState !== "ready" && recordingState !== "saved"
              ? styles.disabled
              : styles.enabled
          }
          onClick={() => {
            if (recordingState !== "ready" && recordingState !== "saved") {
              return;
            }
            setActiveQuestionIndex(
              activeQuestionIndex === 0
                ? questions.length - 1
                : activeQuestionIndex - 1
            );
          }}
        />
        <div className={styles.question}>
          <div className={styles.prompt}>
            <h2>{activeQuestion.prompt}</h2>
          </div>
        </div>
        <ChevronRightOutlined
          className={
            recordingState !== "ready" && recordingState !== "saved"
              ? styles.disabled
              : styles.enabled
          }
          onClick={() => {
            if (recordingState !== "ready" && recordingState !== "saved") {
              return;
            }
            setActiveQuestionIndex(
              activeQuestionIndex === questions.length - 1
                ? 0
                : activeQuestionIndex + 1
            );
          }}
        />
      </div>
      <Record
        question={activeQuestion}
        recordingState={recordingState}
        startCallback={startCallback}
        endCallback={endCallback}
        savedCallback={savedCallback}
        uploadingCallback={uploadingCallback}
      />
    </div>
  ) : null;
}

// helper
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}
